import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-loop-left', 'IconArrowLoopLeft', [
  ['path', { d: 'M13 21v-13a4 4 0 1 1 4 4h-13', key: 'svg-0' }],
  ['path', { d: 'M8 16l-4 -4l4 -4', key: 'svg-1' }],
]);
